<template>
  <div class="contentBox">
    <left-box @mode1="mode1" @mode2="mode2" @mode3="mode3" @mode4="mode4"/>
    <right-box />
  </div>
</template>

<script>
import LeftBox from '@/components/left.vue'
import RightBox from '@/components/right.vue'
export default {
    components:{
      LeftBox,
      RightBox,
    },
    methods:{
      mode1(){
          this.$emit('mode1')
      },
      mode2(){
          this.$emit('mode2')
      },
      mode3(){
          this.$emit('mode3')
      },
      mode4(){
          this.$emit('mode4')
      }
    }
}
</script>

<style  scoped>
.contentBox{
    flex: 1;
    display: flex;
    justify-content: space-between;
}
</style>